import { Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { useStats } from '../../lib/ctx/stats'
import capitalize from 'lodash/capitalize'
import { monthsNames } from '../../lib/utils'

export const StreaksShareCardHeader = () => {
  const { colors } = useTheme()
  const [month, year, theme] = useStats((s) => [s.streakMonth, s.year, s.theme])
  const monthName = monthsNames[month - 1]

  return (
    <div>
      <Text type="label" sizing="L" weight="500" color={colors.uiWhite}>
        Reading streak
      </Text>
      <Text
        className={css`
          margin-top: 2px;
        `}
        type="header"
        custom={{
          fontSize: '40px',
          lineHeight: '40px',
        }}
        weight="500"
        color={theme.primary}
      >
        {capitalize(monthName)} {year}
      </Text>
    </div>
  )
}
